module.exports = __webpack_public_path__ + "img/tabicon.3f3912de.svg";